import { IconButton, InputAdornment, TextField } from '@mui/material'
import tw from 'twin.macro'
// import { ActionButton } from 'src/components/shared/ActionButton'
import { CircleCancelMinor, SearchMinor } from '@shopify/polaris-icons'
import { ChangeEvent, memo, useCallback, useEffect, useRef, useState } from 'react'
import _ from 'lodash'

interface Props {
  searchQuery: string
  onChangeSearchQuery: (search: string) => void
  className?: string
}

const TableSearchComponent = ({ searchQuery, onChangeSearchQuery, className }: Props) => {
  const searchDebounce = useRef(_.debounce(onChangeSearchQuery, 700))

  const [searchValue, setSearchValue] = useState<string>(searchQuery)

  const handleSearchChange = useCallback((e: ChangeEvent<HTMLInputElement>) => {
    setSearchValue(e.target.value)
  }, [])

  useEffect(() => {
    searchDebounce.current(searchValue)
  }, [searchValue])

  const handleClear = useCallback(() => {
    setSearchValue('')
    onChangeSearchQuery('')
  }, [])

  return (
    <div
      css={tw`bg-white flex rounded-lg flex-row overflow-hidden w-[400px]`}
      className={className}
    >
      <TextField
        placeholder="Search"
        type="text"
        variant="outlined"
        fullWidth
        value={searchValue}
        size="small"
        onChange={handleSearchChange}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchMinor width={20} />
            </InputAdornment>
          ),
          endAdornment: searchQuery && (
            <InputAdornment position="end">
              <IconButton css={tw`mr-[-12px] rounded-none`} onClick={handleClear}>
                <CircleCancelMinor width={20} fill="#B4AFC0" />
              </IconButton>
            </InputAdornment>
          ),
          sx: {
            '&:not(.Mui-focused) .MuiOutlinedInput-notchedOutline': {
              border: '1px solid var(--Shades-Grey-100, #EDEDED)',
            },
          },
        }}
      />
      {/* <ActionButton
          text="Search by: Whole table"
          color="white"
          className={tw`bg-white hover:bg-[#FAFAFA] rounded-none`}
        /> */}
    </div>
  )
}

export const TableSearch = memo(TableSearchComponent)
